import { render, staticRenderFns } from "./SymbolGroupView.vue?vue&type=template&id=2b3fa78e&"
import script from "./SymbolGroupView.vue?vue&type=script&lang=js&"
export * from "./SymbolGroupView.vue?vue&type=script&lang=js&"
import style0 from "./SymbolGroupView.vue?vue&type=style&index=0&id=2b3fa78e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports